import {ADVANCE_PROCENT} from "../generalConstants.js/generalConstants";

//StockPool
export default class SP_ASSET {
  constructor(stockPool) {
    const requestInfo = stockPool?.requestInfo;

    // this.skuPlan = stockPool?.skuPlan;
    // this.SKU_PLAN = new SKU_PLAN_LIST_ASSET(stockPool?.skuPlan);
    this.total = stockPool?.total;
    this.services = requestInfo?.servicesInfo;

    this.advance = ADVANCE_PROCENT / 100;
    this.advanceForServices = requestInfo?.advanceForServices;

    this.totalSumWithoutDiscount = requestInfo?.totalSumWithoutDiscount;
    this.discount = requestInfo?.discount;
    this.totalSumWithDiscount = requestInfo?.totalSumWithDiscount;
    this.advancePrice = requestInfo?.advancePrice;
    this.advanceSkuSum = requestInfo?.advanceSkuSum;
    this.surchargePrice = requestInfo?.surchargePrice;

    this.sumPlan = +stockPool?.sumPlan;
  }

  get discountSum() {
    return this.totalSumWithoutDiscount - this.totalSumWithDiscount;
  }

  get stockPoolAdvance() {
    return this.advanceForServices ? this.advancePrice : this.advanceSkuSum;
  }
}
